<div class="px-4 pb-4">
  <div class="">
    <form [formGroup]="formGroupInput()">
      <app-validated-input
        [label]="'admin.common.details.code' | translate"
        inputFormControlName="code"
        [inputFormControl]="formGroupInput().controls.code"
        [validationTrainslations]="{
          required: 'validation.required',
          maxlength: 'validation.maxLength',
          codeTaken: 'validation.codeTaken'
        }"
      ></app-validated-input>
      <app-validated-input
        [label]="'admin.common.details.description' | translate"
        inputFormControlName="description"
        [inputFormControl]="formGroupInput().controls.description"
      ></app-validated-input>
    </form>
  </div>
  @if (showButtons) {
  <div class="d-flex justify-content-end gap-2 px-4 py-4">
    <app-button
      [label]="'general.cancel' | translate"
      variant="default"
      (clicked)="cancel()"
    />
    <app-button
      [iconClass]="'fas fa-save'"
      [label]="'general.save' | translate"
      btnClass="btn btn-primary btn-sm action-btn"
      (clicked)="save()"
      [disabled]="disableSave()"
    />
  </div>
  }
</div>
